mutation InitiateImport2Import($input: ImportInitiateInput!) {
    import2Initiate(input: $input) {
        originId
        externalImportId
        redirectUrl
        isNewImport
    }
}
